<template>
  <main v-if="typedEntity">
    <NodePage
      v-if="typedEntity.bundle === 'page'"
      v-bind="typedEntity.entity"
    />
    <NodeFilterPage
      v-else-if="typedEntity.bundle === 'filter_page'"
      v-bind="typedEntity.entity"
    />
    <NodePressRelease
      v-else-if="typedEntity.bundle === 'press_release'"
      v-bind="typedEntity.entity"
    />
    <NodeNews
      v-else-if="typedEntity.bundle === 'news'"
      v-bind="typedEntity.entity"
    />
    <NodeTopicPage
      v-else-if="typedEntity.bundle === 'topic'"
      v-bind="typedEntity.entity"
    />
    <NodeOrganizationPage
      v-else-if="typedEntity.bundle === 'organization_page'"
      v-bind="typedEntity.entity"
    />
    <NodeEvent
      v-else-if="typedEntity.bundle === 'event'"
      v-bind="typedEntity.entity"
    />
    <NodeGarbageMaterial
      v-else-if="typedEntity.bundle === 'garbage_material'"
      v-bind="typedEntity.entity"
    />
  </main>
</template>

<script setup lang="ts">
const { typedEntity } = await useDrupalRouteQuery('anyNode')

await renderPageDependencies()
</script>
